import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, OnDestroy, Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { dateToString } from 'src/app/core/util/date-converter';
import { TrackingCategory } from '../models/tracking-categories.ts/trackingCategory';
import { PaymentAccount } from '../models/account/payment-account';
import { SupplierShort } from '../models/supplier/supplier-short';
import { TrackingCategoryOption } from '../models/tracking-categories.ts/tracking-category-option';
import { Tag } from 'src/app/data/model/tag';
import { SuppliersService } from 'src/app/data/service/suppliers.service';
import { OrganizationService } from 'src/app/data/service/organization.service';
import { ToasterMessageService } from 'src/app/shared/toaster-message/toaster-message.service';
import { take } from 'rxjs/operators';
import { ToasterTypes } from 'src/app/core/enum/toaster-type.enum';
import { BookkeepingFilter } from '../models/filter/bookkeeping-filter';
import { Location } from '@angular/common';
import { FilterService } from 'src/app/data/service/filter.service';
import { ReportFilter } from 'src/app/data/model/reportFilter';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/data/service/user.service';
import * as $ from "jquery";
import { InvoiceStatus } from '../enums/invoice-status';
import { Unreconciledreportperiod } from 'src/app/core/enum/Unreconciledreport-period.enum';
import { ReportPeriod } from 'src/app/core/enum/report-period.enum';
import moment from 'moment';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { NewReport } from '../models/supplier/new-report';
import { ReportShort } from '../models/supplier/report-short';
import { UnreconciledReportService } from 'src/app/data/service/UnreconciledReport.service';
import { tryGetObjectByProperty } from 'src/app/core/util/get-object-by-property';
import { ReportWithAlias } from '../models/ReportWithAlias';
import { User } from '../models/user/user';

enum FilterMenuSection {
  Main,
  Date,
  Category,
  Supplier,
  Tag,
  TrackingCategory1,
  TrackingCategory2
}


@Component({
  selector: 'app-filter-sidebar',
  templateUrl: './filter-sidebar-component.html',
  styleUrls: ['./filter-sidebar-component.scss']
})

@Injectable({
  providedIn: 'root'
})

export class FilterSidebarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isSidebarVisible: boolean;
  @Input() tags: Tag[] = [];
  @Input() trackingCategories: TrackingCategory[] = [];
  @Input() selectedTrackingCategories: TrackingCategory[] = [];
  @Input() selectedSuppliers: SupplierShort[] = [];
  @Input() selectedSubmitters: User[] = [];
  @Input() selectedAssignedTo: User[] = [];
  @Input() selectedTags: Tag[] = [];
  @Input() accounts: PaymentAccount[] = [];
  @Input() filter = new BookkeepingFilter();
  @Input() filterId: string = '';
  @Input() isEditMode: boolean = false;
  @Input() invoiceStatus: InvoiceStatus | null;
  // Status filter — mirrors the For Review / Processed toolbar pills.
  @Input() statusForReview: boolean = true;
  @Input() statusProcessed: boolean = false;
  @Input() isUnreconciledReport: boolean = false;
  @Input() reports: ReportShort[] = [];
  @Output() updateInvoices: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() newItemEvent = new EventEmitter<ReportFilter>();
  @Output() closeEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  @Output() filterStateChange = new EventEmitter<{ criteria: string, hasActiveFilters: boolean, status?: { forReview: boolean, processed: boolean } }>();

  importData: any = { success: [], error: [], type: 'success', active: false }
  suppliers: SupplierShort[] = [];
  subscriptions: Subscription[] = [];
  filterName: string = "";
  isEditable: boolean = false;
  showDateFilter: boolean = false;
  filterDateRange: DateRange<Date> = null;
  filterDateRangeOption: string = null;
  dateRange; string = "";

  filterUrlPattern: string = '';
  filterUrlPatternOrg: string = '';
  private status = InvoiceStatus;

  dateFormat: string = null;
  currentFilterMenuSection: FilterMenuSection = FilterMenuSection.Main;
  filterMenuSections = FilterMenuSection;

  // Allow parent components to open a specific section of the filter sidebar
  showFilterSection(section: FilterMenuSection) {
    this.currentFilterMenuSection = section;
    this.clearSearchValue();
  }

  // Open a named field (from a table header) and highlight its control briefly
  openSectionForField(fieldName: string) {
    const map = {
      supplier: this.filterMenuSections.Supplier,
      date: this.filterMenuSections.Date,
      category: this.filterMenuSections.Category,
      tags: this.filterMenuSections.Tag,
      tracking1: this.filterMenuSections.TrackingCategory1,
      tracking2: this.filterMenuSections.TrackingCategory2,
      submitter: this.filterMenuSections.Main,
      total: this.filterMenuSections.Main,
      type: this.filterMenuSections.Main,
      default: this.filterMenuSections.Main
    } as any;

    const section = map[fieldName] ?? map['default'];
    this.currentFilterMenuSection = section;
    this.clearSearchValue();

    // set highlight and scroll into view
    this.highlightedField = fieldName;
    setTimeout(() => {
      const selector = `[data-field="${fieldName}"]`;
      const el = document.querySelector(selector) as HTMLElement;
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.classList.add('highlighted');
        setTimeout(() => el.classList.remove('highlighted'), 2200);
      }
      // try to open dropdowns (if any) for better UX
      if (fieldName === 'supplier' || fieldName === 'tags' || fieldName === 'category') {
        const dropdownEl = document.querySelector(`${selector} .custom_mat_select`);
        if (dropdownEl && (dropdownEl as HTMLElement).click) {
          (dropdownEl as HTMLElement).click();
        }
      }
    }, 80);
  }

  // Reset any search values used by filter sections
  clearSearchValue() {
    this.searchedSuppliers = this.suppliers;
    this.searchedAccounts = this.accounts;
    this.searchedTags = this.tags;
    this.searchedTrackingOprions1 = this.selectedTrackingCategories && this.selectedTrackingCategories.length > 0 ? this.selectedTrackingCategories[0].options : null;
    this.searchedTrackingOprions2 = this.selectedTrackingCategories && this.selectedTrackingCategories.length > 1 ? this.selectedTrackingCategories[1].options : null;
    this.tagSearchTerm = null;
  }

  filterCategories: PaymentAccount[] = [];
  filterSuppliers: SupplierShort[] = [];
  filterTags: Tag[] = [];
  filterTrackingOptions1: TrackingCategoryOption[] = [];
  selectedTrackingOptions1: TrackingCategoryOption[] = [];
  filterTrackingOptions2: TrackingCategoryOption[] = [];
  filterSubmitters: User[] = [];
  filterAssignedTo: User[] = [];

  tagSearchTerm: string = null;
  searchedSuppliers: SupplierShort[];
  searchedAccounts: PaymentAccount[];
  searchedTags: Tag[];
  searchedTrackingOprions1: TrackingCategoryOption[];
  searchedTrackingOprions2: TrackingCategoryOption[];
  dropdownSettings = {};
  supplierDropdownSettings = {};
  tagsDropdownSettings = {};
  trackingDropdownSettings = {};
  dropdownBankSettings = {};
  submitterDropdownSettings = {};
  assignedToDropdownSettings = {};
  // Status filter dropdown — mirrors the For Review / Processed toolbar pills.
  statusOptions = [
    { id: 'forReview', name: 'For Review' },
    { id: 'processed', name: 'Processed' }
  ];
  selectedStatusOptions: { id: string, name: string }[] = [];
  statusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'All',
    unSelectAllText: 'All',
    itemsShowLimit: 2,
    allowSearchFilter: false
  };
  userDetails: any;
  searchCriterias: string[] = [];
  isDirty: boolean = false;
  isPinned: boolean = false;
  filterSeqName: string = "";
  isTagsAssigned: boolean = false;
  isTrackingAssigned: boolean = false;
  isSpinnerShown: boolean = false;
  SelctedReportName: string = "";
  
  newFilterName: string = "";

  filterBank: PaymentAccount[] = [];
  DateRangeSelcted: string = "";
  unreconciledreportperiod = Unreconciledreportperiod;
  reportPeriod = ReportPeriod;
  bankAccountList: PaymentAccount[] = [];
  filterType: string = '';
  isXeroAccount: boolean = false;
  showDateRange: string = "";
  Source = "Spreadsheet";
  newReport: NewReport = new NewReport(this._organizationService.selectedOrganization);
  isCreateReportItemShown: boolean = false;
  isNewReport: boolean = false;
  isLoaded: boolean = false;
  isNewReportLoaded: boolean = false;
  creatingNewReport: boolean = false;
  // Field to briefly highlight when opening sidebar for a specific field
  highlightedField: string = null;
  mailModel = {
    Name: '',
    Email: '',
    TransCnt: 0,
    ID: '',
    ReportName: null,
    UnreconciledReportId: ''
  };
  currentReport: ReportWithAlias = new ReportWithAlias();
  reportName: string = "";
  isStep1Completed: boolean = false;
  isEditModeStep: boolean = false;
  constructor(
    private readonly _location: Location,
    private readonly _suppliersService: SuppliersService,
    private readonly _organizationService: OrganizationService,
    private readonly _toasterMessageService: ToasterMessageService,
    private readonly _filterService: FilterService,
    private reportServ: UnreconciledReportService,
    private _userService: UserService,
  ) {
    this.dateFormat = sessionStorage.getItem('orgDateFormat');
    this.filterType = '';
  }

  GetBankAcoountDetails() {
    this._organizationService.GetBankAccountDetails("Organisation/GetBankAccountDetails", sessionStorage.organizationId).subscribe((response: any) => {
      if (response.status == 0) {
        this.bankAccountList = response.data;
        this.filterBank?.forEach(element => {
          element.checked = true;
        });
      }
    }, err => {
      this.bankAccountList = [];
    });
  }

  ngOnInit(): void {
    this.syncStatusSelection();
    this._organizationService.organizationList.subscribe(data => {
      if (data) {
        const getOrganization = data.find(x => x.organisationID.toLowerCase() == sessionStorage.organizationId.toLowerCase());
        if (getOrganization) {
          this.isXeroAccount = getOrganization.accountingIntegration;
        }

      }
    });

    this.filterType = '';
    this.GetBankAcoountDetails();

    this.SelctedReportName = "Import Transactions";

    this.getLatestFilterNumber();
    this.getSuppliers();
    this.getUsers();
    this.subscriptions.push(this._userService.loggedUserDetails
      .subscribe(data => {
        if (data) {
          this.userDetails = data;
        } else {
          this.userDetails = [];
        }
      }));

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.supplierDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.tagsDropdownSettings = {
      singleSelection: false,
      idField: 'tagId',
      textField: 'tagName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.trackingDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.dropdownBankSettings = {
      singleSelection: false,
      idField: 'accountID',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.submitterDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.assignedToDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusForReview'] || changes['statusProcessed']) {
      this.syncStatusSelection();
    }
  }

  // Reflect the pill state into the Status multi-select.
  private syncStatusSelection(): void {
    this.selectedStatusOptions = this.statusOptions.filter(o =>
      (o.id === 'forReview' && this.statusForReview) ||
      (o.id === 'processed' && this.statusProcessed)
    );
  }

  // The Status filter is deferred like every other filter — changing it only
  // updates local state; it is applied when "Apply Filters" is clicked.
  onStatusSelectionChange(): void {
    const forReview = (this.selectedStatusOptions || []).some(o => o.id === 'forReview');
    const processed = (this.selectedStatusOptions || []).some(o => o.id === 'processed');
    // At least one status must stay selected.
    if (!forReview && !processed) { this.syncStatusSelection(); }
    this.isDirty = true;
  }

  onStatusSelectAll(): void {
    this.selectedStatusOptions = [...this.statusOptions];
    this.isDirty = true;
  }

  onStatusDeSelectAll(): void {
    // At least one status must stay selected — restore the current state.
    this.syncStatusSelection();
  }

  // True when the Status selection differs from the currently-applied status
  // (the pills) — lets "Apply Filters" enable for a status-only change.
  isStatusChanged(): boolean {
    const forReview = (this.selectedStatusOptions || []).some(o => o.id === 'forReview');
    const processed = (this.selectedStatusOptions || []).some(o => o.id === 'processed');
    return forReview !== this.statusForReview || processed !== this.statusProcessed;
  }

  // The Status the user has selected in the panel (applied on "Apply Filters").
  getSelectedStatus(): { forReview: boolean, processed: boolean } {
    return {
      forReview: (this.selectedStatusOptions || []).some(o => o.id === 'forReview'),
      processed: (this.selectedStatusOptions || []).some(o => o.id === 'processed')
    };
  }

  saveContactForm(fieldName: string) {
  }
  startDate = new Date;
  lastDayOfMonth = new Date;
  keyInEnum(): Array<string> {
    var keys;
    if (this.SelctedReportName == 'Unreconciled Items') {

      this.DateRangeSelcted = "This Month";

      keys = Object.values(this.unreconciledreportperiod);
    }
    else {
      keys = Object.values(this.reportPeriod);
    }
    this.startDate = new Date;
    this.lastDayOfMonth = new Date;
    if (this.DateRangeSelcted == "This Month") {
      this.startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
      this.lastDayOfMonth = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");
    }
    else if (this.DateRangeSelcted == "Last Month") {

      this.startDate = new Date(moment((this.currentdateitem)).format("MM/DD/YYYY"));
      this.lastDayOfMonth = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0);
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");

    }
    else if (this.DateRangeSelcted == "This Quarter") {
      var quarter = Math.floor((this.date.getMonth() + 3) / 3)
      var quarterstart = moment(this.date.getFullYear(), "YYYY").quarter(quarter).startOf('quarter');
      var quarterend = moment(this.date.getFullYear(), "YYYY").quarter(quarter).endOf('quarter');
      this.startDate = quarterstart.toDate();
      this.lastDayOfMonth = quarterend.toDate();
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");

    }
    else if (this.DateRangeSelcted == "Last Quarter") {
      var quarter = Math.floor((this.date.getMonth() / 3));
      var quarterstart = moment(this.date.getFullYear(), "YYYY").quarter(quarter).startOf('quarter');
      var quarterend = moment(this.date.getFullYear(), "YYYY").quarter(quarter).endOf('quarter');
      this.startDate = quarterstart.toDate();
      this.lastDayOfMonth = quarterend.toDate();
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");
    }
    else if (this.DateRangeSelcted == "This Financial Year") {
      this.startDate = new Date("07/01/" + (this.dateitem.getFullYear() - 1));
      this.lastDayOfMonth = new Date("06/30/" + this.date.getFullYear());
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");
    }
    else if (this.DateRangeSelcted == "Last Financial Year") {
      this.startDate = new Date("07/01/" + (this.dateitem.getFullYear() - 2));
      this.lastDayOfMonth = new Date("06/30/" + (this.dateitem.getFullYear() - 1));
      this.showDateRange = moment(this.startDate).format("MM/DD/YYYY") + " to " + moment(this.lastDayOfMonth).format("MM/DD/YYYY");
    }

    return keys.slice().filter(e => e !== 'Custom Range');
  }



  getLatestFilterNumber() {
    this._filterService.getLatestFilterName("Filter/GetLatestFilterNumber", 1, this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (name) => {
          this.filterName = name.data;
          this.filterSeqName = name.data;
        });
  }

  getSuppliers() {
    this._suppliersService.getSuppliers(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.suppliers = data.sort((a, b) => a.name.localeCompare(b.name)) || [];

          this.searchedSuppliers = this.suppliers;
          this.searchedTags = this.tags;
          this.searchedAccounts = this.accounts;
          if (this.selectedTrackingCategories && this.selectedTrackingCategories.length > 0) {
            this.searchedTrackingOprions1 = this.selectedTrackingCategories[0].options;
            if (this.selectedTrackingCategories.length > 1) {
              this.searchedTrackingOprions2 = this.selectedTrackingCategories[1].options;
            }
            if (this.selectedTrackingCategories && this.selectedTrackingCategories.length > 0) {
              this.searchedTrackingOprions1.splice(0, 0, { id: '0', name: 'Unassigned', trackingCategoryId: '', group: 0 });
            }
          }

          this.showTagsFromAddressBar();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
        }
      );
  }

  private showTagsFromAddressBar() {
    this.filterSuppliers?.forEach(element => {
      element.checked = true;
    });

    this.filterCategories?.forEach(element => {
      element.checked = true;
    });

    this.filterTags?.forEach(element => {
      element.checked = true;
    });

    this.filterTrackingOptions1?.forEach(element => {
      element.checked = true;
    });

    this.filterTrackingOptions2?.forEach(element => {
      element.checked = true;
    });
  }

  CloseTheFilterSidebar(filter: ReportFilter) {
    this.newItemEvent.emit(filter);
    this.showDateFilter = false;
    this.isEditable = true;
    this.selectedSuppliers = [];
    this.selectedTags = [];
    this.filterCategories = [];
    this.filterDateRange = null;
    this.filterSuppliers = [];
    this.filterTags = [];
    this.dateRange = null;
    this.filterName = this.filterSeqName;

    this.filterBank = [];
    this.isEditMode = false;
    this.isDirty = false;
    this.isPinned = false;
  }

  ClearTheFilterSidebar() {
    this.showDateFilter = false;
    this.isEditable = true;
    this.selectedSuppliers = [];
    this.selectedTags = [];
    this.filterCategories = [];
    this.filterDateRange = null;
    this.filterSuppliers = [];
    this.filterTags = [];
    this.dateRange = null;
    this.filterName = "";

    this.filterBank = [];
    // Clear amount filters
    this.filter.amountMin = null;
    this.filter.amountMax = null;
    this.isEditMode = false;
    this.isDirty = false;
    this.isPinned = false;
  }

  CloseFilterSidebar() {
    // Emit filter state change before closing
    this.filterStateChange.emit({
      criteria: this.searchCriterias.join('&'),
      hasActiveFilters: false
    });

    this.closeEvent.emit();
    this.showDateFilter = false;
    this.isEditable = true;
    this.selectedSuppliers = [];
    this.selectedTags = [];
    this.filterCategories = [];
    this.filterDateRange = null;
    this.filterSuppliers = [];
    this.filterTags = [];
    this.dateRange = null;
    this.filterName = this.filterSeqName;

    this.filterBank = [];
    // Clear amount filters when closing
    this.filter.amountMin = null;
    this.filter.amountMax = null;
    this.GetFilterData();
    this.isEditMode = false;
    this.isDirty = false;
    this.isPinned = false;
  }

  toogleDateFilter() {
    this.showDateFilter = !this.showDateFilter;
  }

  setDateRange(event) {
    if (event.target != undefined && event.target.value == "") {
      this.filterDateRange = null;
      this.dateRange = "";
      this.filterDateRangeOption = null;
      this.updateFilter('invoiceDateRange', null);
      this.showDateFilter = false;
    }
    else {

      this.filterDateRange = event.selectedDateRange;
      this.filterDateRangeOption = event.selectedOption;
      this.dateRange = dateToString(this.filterDateRange.start) + " - " + dateToString(this.filterDateRange.end);
      this.toogleDateFilter();
      this.updateFilter('invoiceDateRange', [this.filterDateRange.start, this.filterDateRange.end]);
    }
    this.isDirty = true;
  }

  clearSelectedDateRange() {
    this.filterDateRange = null;
    this.dateRange = "";
    this.filterDateRangeOption = null;
    this.updateFilter('invoiceDateRange', null);
    this.showDateFilter = false;

    // Emit filter state change
    this.filterStateChange.emit({
      criteria: this.filterUrlPattern,
      hasActiveFilters: this.hasActiveFilters()
    });
  }

  onItemSelect(item: any) {
    this.updateFilter('categories', this.filterCategories.map(c => c.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onSelectAll(items: any) {
    this.filterCategories = items;
    this.updateFilter('categories', this.filterCategories.map(c => c.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onDeleteGroup(item: any) {
    this.filterCategories = Object.values(this.filterCategories).filter(g => g.id != item.typeId);
    this.updateFilter('categories', this.filterCategories.map(c => c.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onDeleteAllGroup(item: any) {
    this.filterCategories = [];
    this.updateFilter('categories', this.filterCategories.map(s => s.id.replace('&', '%26')));
    this.isDirty = true;
  }

  onSupplierItemSelect(item: any) {
    // this.selectedSuppliers.push(item);
    this.filterSuppliers.push(item);
    this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onSupplierSelectAll(items: any) {
    this.filterSuppliers = items;
    this.selectedSuppliers = items;
    this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onSupplierDeleteGroup(item: any) {
    this.filterSuppliers = Object.values(this.filterSuppliers).filter(g => g.name != item.name);
    this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
    this.selectedSuppliers = this.filterSuppliers;
    this.isDirty = true;
  }

  onSupplierDeleteAllGroup(item: any) {
    this.filterSuppliers = [];
    this.selectedSuppliers = [];
    this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onTagItemSelect(item: any) {
    if (item.tagName == "Unassigned") {
      let data = this.searchedTags;
      let selectedItem = data.filter(item1 => item1.tagId == item.tagId);
      let selectedItemGroup = selectedItem[0]['group'];
      this.searchedTags = data.map(s => {
        if (s.group == selectedItemGroup) {
          s.isDisabled = false;
        } else {
          s.isDisabled = true;
        }
        return s;
      });
      this.isTagsAssigned = true;
      this.selectedTags = Object.values(this.selectedTags).filter(g => g.tagName == "Unassigned");
      this.updateFilter('tags', "Unassigned tags");
    }
    else {
      this.isTagsAssigned = false;
      this.updateFilter('tags', this.selectedTags.map(t => t.tagName));
    }
    this.isDirty = true;

  }

  onTagSelectAll(items: Tag[]) {
    this.tags = this.tags.map(s => {
      if (s.group === 0) {
        s.isDisabled = true;
      } else {
        s.isDisabled = false;
      }
      return s;
    });
    this.selectedTags = Object.values(items).filter(g => g.tagName != "Unassigned");
    this.updateFilter('tags', this.selectedTags.map(t => t.tagName));
    this.isDirty = true;
  }

  onTagDeleteGroup(item: any) {
    if (this.searchedTags && this.searchedTags.length > 0) {
      this.searchedTags = this.searchedTags.map(s => {
        s.isDisabled = false;
        return s;
      });
    }
    this.isTagsAssigned = false;
    this.selectedTags = Object.values(this.filterTags).filter(g => g.tagId != item.tagId);
    this.updateFilter('tags', this.selectedTags.map(t => t.tagName));
    this.isDirty = true;
  }

  onTagDeleteAllGroup(item: any) {
    if (this.tags && this.tags.length > 0) {
      this.tags = this.tags.map(s => {
        s.isDisabled = false;
        return s;
      });
    }
    this.selectedTags = [];
    this.updateFilter('tags', this.selectedTags.map(s => s.tagName.replace('&', '%26')));
    this.isDirty = true;
  }

  onTracking1ItemSelect(item: any) {
    if (item.name == "Unassigned") {
      let data = this.searchedTrackingOprions1;
      let selectedItem = data.filter(item1 => item1.id == item.id);
      let selectedItemGroup = selectedItem[0]['group'];
      this.searchedTrackingOprions1 = data.map(s => {
        if (s.group == selectedItemGroup) {
          s.isDisabled = false;
        } else {
          s.isDisabled = true;
        }
        return s;
      });
      this.isTrackingAssigned = true;
      this.filterTrackingOptions1 = Object.values(this.filterTrackingOptions1).filter(g => g.name == "Unassigned");
      this.updateFilter('trackingOptions1', "Unassigned tracking");
    }
    else {
      this.isTrackingAssigned = false;
      this.updateFilter('trackingOptions1', this.filterTrackingOptions1.map(t => t.name));
    }
    this.isDirty = true;
  }

  onTracking1SelectAll(items: TrackingCategoryOption[]) {
    this.searchedTrackingOprions1 = this.searchedTrackingOprions1.map(s => {
      if (s.group === 0) {
        s.isDisabled = true;
      } else {
        s.isDisabled = false;
      }
      return s;
    });
    this.filterTrackingOptions1 = Object.values(items).filter(g => g.name != "Unassigned");
    this.updateFilter('trackingOptions1', this.filterTrackingOptions1.map(t => t.name));
    this.isDirty = true;
  }

  onTracking1DeleteGroup(item: any) {
    if (this.searchedTrackingOprions1 && this.searchedTrackingOprions1.length > 0) {
      this.searchedTrackingOprions1 = this.searchedTrackingOprions1.map(s => {
        s.isDisabled = false;
        return s;
      });
    }
    this.filterTrackingOptions1 = Object.values(this.filterTrackingOptions1).filter(g => g.name != item.name);
    this.isTrackingAssigned = false;
    this.updateFilter('trackingOptions1', this.filterTrackingOptions1.map(t => t.name));
    this.isDirty = true;
  }

  onTracking1DeleteAllGroup(item: any) {
    this.searchedTrackingOprions1 = this.searchedTrackingOprions1.map(s => {
      s.isDisabled = false;
      return s;
    });
    this.filterTrackingOptions1 = [];
    this.updateFilter('trackingOptions1', this.filterTrackingOptions1.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  public date = new Date();
  public dateitem = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  public currentdateitem = this.dateitem.setMonth(this.dateitem.getMonth() - 1);
  public start: Date = new Date(moment((this.currentdateitem)).format("MM/DD/YYYY"));
  public end: Date = new Date(moment((this.date)).format("MM/DD/YYYY"));

  reportPeriodChange($event) {
    this.DateRangeSelcted = $event.target.value;
  }

  onBankItemSelect(item: any) {
    this.updateFilterBank('accounts', this.filterBank.map(c => c.accountID.replace('&', '%26')));
    this.isDirty = true;
  }

  onBankSelectAll(items: any) {
    this.filterBank = items;
    this.updateFilterBank('accounts', this.filterBank.map(c => c.accountID.replace('&', '%26')));
    this.isDirty = true;
  }
  onBankDeleteItem(item: any) {
    this.filterBank = Object.values(this.filterBank).filter(g => g.accountID != item.accountID);
    this.updateFilterBank('accounts', this.filterBank.map(c => c.accountID.replace('&', '%26')));
    this.isDirty = true;
  }

  updateFilterBank(field: string, value: any) {
    this.filter[field] = value;
  }
  imprtSuccessGrp: any = [];
  imprtErrorGrp: any = [];
  redirectToreport() {
    let bankPart = this.filter.accounts?.length > 0 ? this.filter.accounts?.map(s => `${s},`).join('').slice(0, -1) : '';

    let str: string = JSON.stringify({ 'account': bankPart.substring(0, bankPart.length), 'DateRangeSelcted': this.DateRangeSelcted });

    this.isSpinnerShown = true;
    //this.filterUrlPattern = `?${bankPart}&DateRangeSelcted=${this.DateRangeSelcted}`;
    if (this.filter.accounts?.length > 0
      || (this.filter.invoiceDateRange && this.filter.invoiceDateRange[0])) {
      //
      // ISO 8601 -- see the note in import-transactions.component.ts importFromXero().
      // Anything else fails to bind and the request silently returns no data.
      var startDate = moment((this.startDate)).format("YYYY-MM-DD");
      var lastDayOfMonth = moment((this.lastDayOfMonth)).format("YYYY-MM-DD");

      var reportDataModel = {
        organizationId: sessionStorage.organizationId,
        userid: Number(sessionStorage.UserId),
        id: sessionStorage.Id,
        startDate: startDate === "Invalid date" ? "1900-01-01" : startDate,
        endDate: lastDayOfMonth === "Invalid date" ? "2048-01-01" : lastDayOfMonth,
        isSavedReport: false,
        isoutstandingReport: false,
        isSavedReportData: false,
        Source: 'XeroDataCheck',// "Report",
        reportId: undefined,
        Account: bankPart.substring(0, bankPart.length)
      }



      this._organizationService.GetUnreconciledReportList(reportDataModel).subscribe(data => {

        this.isSpinnerShown = false;

        this.importData = { success: [], error: [], type: 'success', active: true };
        this.Source = "Report";
        data.data.forEach((val) => {
          //val.trannsactionDate=val.transactionDate;
          if (val.importStatus == "success") {
            val.isImport = true;
            this.importData.success.push(val);


          }
          else {
            this.importData.error.push(val);
          }
        })

        this.imprtSuccessGrp = this.groupRecord(this.importData.success);
        this.imprtSuccessGrp.forEach(element => {
          element.ischeck = true;
        });
        this.imprtErrorGrp = this.groupRecord(this.importData.error);
      });


    } else {
      this.closeFilter.emit(false);
    }
  }
  setCheckUnCheck(array, isbool) {
    array.forEach(item => {
      item.isImport = isbool;
    })

  }
  groupRecord(list) {
    let grpLst = [];
    list.forEach((item) => {

      if (grpLst.length > 0) {
        let isExists = false;
        grpLst.forEach(element => {
          if (element.key == item.accountName) {
            element.value.push(item);
            isExists = true;
          }

        });
        if (!isExists) {
          grpLst.push({ key: item.accountName, value: [item], ischeck: false });
        }
      }
      else {
        grpLst.push({ key: item.accountName, value: [item], ischeck: false });
      }
    });
    return grpLst;

  }
  updateFilter(field: string, value: any) {
    this.filter[field] = value;

    let supplierPart = this.filter.suppliers?.length > 0 ? this.filter.suppliers?.map(s => `suppliers=${s}&`).join('').slice(0, -1) : 'suppliers=';
    let categoryPart = this.filter.categories?.length > 0 ? this.filter.categories?.map(c => `categories=${c}&`).join('').slice(0, -1) : 'categories=';
    let submitterPart = this.filter.submitters?.length > 0 ? this.filter.submitters?.map(s => `submitters=${s}&`).join('').slice(0, -1) : 'submitters=';
    let assignedToPart = this.filter.assignedTo?.length > 0 ? this.filter.assignedTo?.map(s => `assignedTo=${s}&`).join('').slice(0, -1) : 'assignedTo=';
    let tagPart = "";
    if (this.isTagsAssigned) {
      tagPart = "tags=Unassigned tags";
    }
    else {
      tagPart = this.filter.tags?.length > 0 ? this.filter.tags?.map(t => `tags=${t}&`).join('').slice(0, -1) : 'tags=';
    }
    let trackingOptions1Part = "";
    if (this.isTrackingAssigned) {
      trackingOptions1Part = "track1=Unassigned tracking";
    }
    else {
      trackingOptions1Part = this.filter.trackingOptions1?.length > 0 ? this.filter.trackingOptions1?.map(o => `track1=${o}&`).join('').slice(0, -1) : 'track1=';
    }

    let dateStartPart = this.filter.invoiceDateRange && this.isValidDate(this.filter.invoiceDateRange[0]) && this.filter.invoiceDateRange?.slice(0, 1)[0] ? `dateStart=${dateToString(this.filter.invoiceDateRange[0]) ?? ''}` : 'dateStart=';
    let dateEndPart = this.filter.invoiceDateRange && this.isValidDate(this.filter.invoiceDateRange[0]) && this.filter.invoiceDateRange?.slice(1, 2)[0] ? `dateEnd=${dateToString(this.filter.invoiceDateRange[1]) ?? ''}` : 'dateEnd=';
    let dateOption = this.filterDateRangeOption ? `dateOption=${this.filterDateRangeOption}` : 'dateOption=';
    let statusPart = `status=${this.invoiceStatus == this.status.inProcessing ? 'false' : 'true'}`;

    let trackingOptions2Part = this.filter.trackingOptions2?.length > 0 ? this.filter.trackingOptions2?.map(o => `track2=${o}&`).join('').slice(0, -1) : 'track2=';

    let amountMinPart = (this.filter.amountMin !== null && this.filter.amountMin !== undefined) ? `amountMin=${this.filter.amountMin}` : 'amountMin=';
    let amountMaxPart = (this.filter.amountMax !== null && this.filter.amountMax !== undefined) ? `amountMax=${this.filter.amountMax}` : 'amountMax=';

    this.filterUrlPattern = `?${supplierPart}&${dateOption}&${dateStartPart}&${dateEndPart}&${categoryPart}&${tagPart}&${trackingOptions1Part}&${trackingOptions2Part}&${statusPart}&${submitterPart}&${assignedToPart}&${amountMinPart}&${amountMaxPart}`;
    this._location.replaceState(`/inbox${this.filterUrlPattern}`);

    // Don't automatically apply filters - wait for user to click "Apply Filters"
    // Just update the filter pattern for when they do apply
  }

  isValidDate(dateObject) {
    return new Date(dateObject).toString() !== 'Invalid Date';
  }

  filterInvoices() {
    this.updateInvoices.emit(this.filterUrlPattern);
  }

  // Apply filter without saving
  ApplyFilter() {
    if (this.hasActiveFilters()) {
      this.filterInvoices();
      // Emit filter state + the chosen Status to the parent, which applies
      // both together in a single load.
      this.filterStateChange.emit({
        criteria: this.filterUrlPattern,
        hasActiveFilters: true,
        status: this.getSelectedStatus()
      });
      // Close the filter sidebar after applying filters
      this.closeEvent.emit();
    }
  }

  // Check if there are any active filters (a changed Status counts too, so
  // "Apply Filters" enables for a status-only change).
  hasActiveFilters(): boolean {
    return (
      this.filter.categories?.length > 0
      || this.filter.suppliers?.length > 0
      || this.filter.tags?.length > 0
      || (this.filter.invoiceDateRange && this.filter.invoiceDateRange[0] != null)
      || this.filter.trackingOptions1?.length > 0
      || this.filter.trackingOptions2?.length > 0
      || this.filter.submitters?.length > 0
      || this.filter.assignedTo?.length > 0
      || (this.filter.amountMin !== null && this.filter.amountMin !== undefined)
      || (this.filter.amountMax !== null && this.filter.amountMax !== undefined)
      || this.isStatusChanged()
    );
  }


  SaveFilter() {
    let filter = {
      id: this.filterId,
      name: this.filterName,
      type: 0,
      isPinned: this.isPinned,
      searchCriteria: this.filterUrlPattern,
      createdBy: this.userDetails.id,
      createdDate: new Date(),
      filterPageType: 1,
      organizationId: this._organizationService.selectedOrganization
    } as ReportFilter;

    this._filterService.SaveFilter("", filter)
      .pipe(take(1))
      .subscribe(
        (createdFilter: string) => {
          this._toasterMessageService.displayToasterState(ToasterTypes.Success, "Success", "Filter Saved Successfully.");
          filter.id = createdFilter;
          this.CloseTheFilterSidebar(filter);
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
        }
      );
  }

  GetFilterData() {
    this.isSpinnerShown = true;
    if (this.isEditMode || this.filterUrlPatternOrg == "") {
      if (this.filterUrlPatternOrg != "") {
        this.searchCriterias = this.filterUrlPatternOrg.replace("?", "").split("&");
        for (var i = 0; i < this.searchCriterias.length; i++) {
          if (this.searchCriterias[i].startsWith("suppliers") && this.searchCriterias[i] != "suppliers=") {
            this.filterSuppliers.push(this.suppliers.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("suppliers=", "").replace('%26', '&')));
            this.selectedSuppliers = this.filterSuppliers;
            this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
          }
          if (this.searchCriterias[i].startsWith("tags") && this.searchCriterias[i] != "tags=") {
            if (this.searchCriterias[i] == "tags=Unassigned tags") {
              this.isTagsAssigned = true;
              this.filterTags.push(this.tags.find(x => x.tagName.toLowerCase() === "unassigned"));
              this.selectedTags = this.filterTags;
            } else {
              this.filterTags.push(this.tags.find(x => x.tagName.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("tags=", "").replace('%26', '&')));
              this.selectedTags = this.filterTags;
            }
            this.updateFilter('tags', this.filterTags.map(s => s.tagName.replace('&', '%26')));
          }
          if (this.searchCriterias[i].startsWith("categories") && this.searchCriterias[i] != "categories=") {
            this.filterCategories.push(this.searchedAccounts.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("categories=", "").replace('%26', '&')));
            this.updateFilter('categories', this.filterCategories.map(s => s.name.replace('&', '%26')));
          }
          if (this.searchCriterias[i].startsWith("dateStart") && this.searchCriterias[i] != "dateStart") {
            this.dateRange = this.searchCriterias[i].replace("dateStart=", '') + " - ";
          }
          if (this.searchCriterias[i].startsWith("dateEnd") && this.searchCriterias[i] != "dateEnd") {
            this.dateRange = this.dateRange + this.searchCriterias[i].replace("dateEnd=", '');
            var dateArr = this.dateRange.split(' - ');
            this.filter.invoiceDateRange = [new Date(dateArr[0]), new Date(dateArr[1])];
            this.filterDateRange = new DateRange<Date>(this.filter.invoiceDateRange[0], this.filter.invoiceDateRange[1]);
          }
          if (this.searchCriterias[i].startsWith("dateOption=") && this.searchCriterias[i] != "dateOption=") {
            this.filterDateRangeOption = this.searchCriterias[i].replace("dateOption=", "");
          }
          if (this.searchCriterias[i].startsWith("track1") && this.searchCriterias[i] != "track1=") {
            if (this.searchCriterias[i] == "track1=Unassigned tracking") {
              this.isTrackingAssigned = true;
              this.selectedTrackingOptions1.push(this.searchedTrackingOprions1.find(x => x.name.toLowerCase() === "unassigned"));
              this.filterTrackingOptions1 = this.selectedTrackingOptions1;
            } else {
              this.selectedTrackingOptions1.push(this.searchedTrackingOprions1.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("track1=", "").replace('%26', '&')));
              this.filterTrackingOptions1 = this.selectedTrackingOptions1;
            }
          }
        }
      }
      this.isSpinnerShown = false;
    }
    else {
      this._filterService.GetFilter('Filter/GetReportFilterById', $("#hdFilterId").val())
        .pipe(take(1))
        .subscribe(
          (reportFilter) => {
            this.filterName = reportFilter.name;
            this.filterId = reportFilter.id;
            this.filterUrlPattern = reportFilter.searchCriteria;
            this.isPinned = reportFilter.isPinned;
            this.filterSuppliers = [];
            this.selectedSuppliers = [];
            this.filterTags = [];
            this.filterCategories = [];
            this.selectedTrackingOptions1 = [];
            this.filterTrackingOptions1 = [];

            if (this.filterUrlPattern != "") {
              this.searchCriterias = this.filterUrlPattern.replace("?", "").split("&");

              for (var i = 0; i < this.searchCriterias.length; i++) {
                if (this.searchCriterias[i].startsWith("suppliers") && this.searchCriterias[i] != "suppliers=") {
                  this.filterSuppliers.push(this.suppliers.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("suppliers=", "").replace('%26', '&')));
                  this.selectedSuppliers = this.filterSuppliers;
                  this.updateFilter('suppliers', this.filterSuppliers.map(s => s.name.replace('&', '%26')));
                }
                if (this.searchCriterias[i].startsWith("tags") && this.searchCriterias[i] != "tags=") {
                  if (this.searchCriterias[i] == "tags=Unassigned tags") {
                    this.isTagsAssigned = true;
                    this.filterTags.push(this.tags.find(x => x.tagName.toLowerCase() === "unassigned"));
                    this.selectedTags = this.filterTags;
                  } else {
                    this.filterTags.push(this.tags.find(x => x.tagName.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("tags=", "").replace('%26', '&')));
                    this.selectedTags = this.filterTags;
                  }
                  this.updateFilter('tags', this.filterTags.map(s => s.tagName.replace('&', '%26')));
                }
                if (this.searchCriterias[i].startsWith("categories") && this.searchCriterias[i] != "categories=") {
                  this.filterCategories.push(this.accounts.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("categories=", "").replace('%26', '&')));
                  this.updateFilter('categories', this.filterCategories.map(s => s.name.replace('&', '%26')));
                }
                if (this.searchCriterias[i].startsWith("dateStart") && this.searchCriterias[i] != "dateStart") {
                  this.dateRange = this.searchCriterias[i].replace("dateStart=", '') + " - ";
                }
                if (this.searchCriterias[i].startsWith("dateEnd") && this.searchCriterias[i] != "dateEnd") {
                  this.dateRange = this.dateRange + this.searchCriterias[i].replace("dateEnd=", '');
                  var dateArr = this.dateRange.split(' - ');
                  this.filter.invoiceDateRange = [new Date(dateArr[0]), new Date(dateArr[1])];
                  this.filterDateRange = new DateRange<Date>(this.filter.invoiceDateRange[0], this.filter.invoiceDateRange[1]);
                }
                if (this.searchCriterias[i].startsWith("dateOption=") && this.searchCriterias[i] != "dateOption=") {
                  this.filterDateRangeOption = this.searchCriterias[i].replace("dateOption=", "");
                }
                if (this.searchCriterias[i].startsWith("track1") && this.searchCriterias[i] != "track1=") {
                  if (this.searchCriterias[i] == "track1=Unassigned tracking") {
                    this.isTrackingAssigned = true;
                    this.selectedTrackingOptions1.push(this.searchedTrackingOprions1.find(x => x.name.toLowerCase() === "unassigned"));
                    this.filterTrackingOptions1 = this.selectedTrackingOptions1;
                  } else {
                    this.selectedTrackingOptions1.push(this.searchedTrackingOprions1.find(x => x.name.toLowerCase() === this.searchCriterias[i].toLowerCase().replace("track1=", "").replace('%26', '&')));
                    this.filterTrackingOptions1 = this.selectedTrackingOptions1;
                  }
                }
              }
            }
            this.isSpinnerShown = false;
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
            this.isSpinnerShown = false;
          }
        );
    }
  }
  updateDirty() {
    this.isDirty = true;
  }

  pinnedFilter() {
    this.isPinned = !this.isPinned;

    let filter = {
      id: this.filterId,
      name: this.filterName,
      type: 0,
      isPinned: this.isPinned,
      searchCriteria: this.filterUrlPattern,
      createdBy: this.userDetails.id,
      createdDate: new Date(),
      filterPageType: 3,
      organizationId: this._organizationService.selectedOrganization
    } as ReportFilter;

    this._filterService.SaveFilter("", filter)
      .pipe(take(1))
      .subscribe(
        (createdFilter: string) => {
        },
        (e: Error) => {
        }
      );
  }

  deleteFilter() {
    this._filterService.DeleteFilter('Filter/DeleteFilter', $("#hdFilterId").val())
      .pipe(take(1))
      .subscribe(
        () => {
          this.deleteEvent.emit();
          this.CloseFilterSidebar();
          this._toasterMessageService.displayToasterState(ToasterTypes.Success, 'Success', 'Filter deleted!');
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
        }
      )
  }

  onCheckChange(event) {
    if (event.target.checked) {
      this.updateFilter('tags', "Unassigned tags");
    }
    else {
      this.updateFilter('tags', "");
    }
    this.isDirty = true;
  }

  onTrackCheckChange(event) {
    if (event.target.checked) {
      this.updateFilter('trackingOptions1', "Unassigned tracking");
    }
    else {
      this.updateFilter('trackingOptions1', "");
    }
    this.isDirty = true;
  }




  fileObj: any;
  isFileProcessing: boolean = false;

  added(event: Event) {
    const [uploadedFile] = Array.from((event.target as HTMLInputElement).files as FileList);

    this.fileObj = { name: uploadedFile.name, file: uploadedFile, size: (uploadedFile.size / (1024 * 1024)) };
  }


  dropped(uploadedFiles: NgxFileDropEntry[]) {

    const fileEntry = uploadedFiles[0].fileEntry.isFile ? uploadedFiles[0].fileEntry as FileSystemFileEntry : null;
    fileEntry?.file((files: File) => {
      this.fileObj = { name: files.name, file: files };
    });
  }

  async sendFile() {
    this.isFileProcessing = true;
    this.isSpinnerShown = true;
    let data: any = await this._filterService.uploadExcel({ organisationId: this._organizationService.selectedOrganization, invoice: this.fileObj.file, recordId: "", isBankTransMode: true });
    this.isFileProcessing = false;
    if (data.status == 1) {
      this.importData = { success: [], error: [], type: 'success', active: true };
      this.isSpinnerShown = false;
      this.Source = "Spreadsheet";
      data.data.forEach((val) => {
        if (val.importStatus == "success") {
          val.isImport = true;
          this.importData.success.push(val);
        }
        else {
          this.importData.error.push(val);
        }
      })

      this.imprtSuccessGrp = this.groupRecord(this.importData.success);
      this.imprtSuccessGrp.forEach(element => {
        element.ischeck = true;
      });
      this.imprtErrorGrp = this.groupRecord(this.importData.error);
    }
    else {
      this.isFileProcessing = false;
      this.isSpinnerShown = false;
      this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', data.message);
    }
  }

  async uploadImportExcel() {
    this.isFileProcessing = true;
    this.isSpinnerShown = true;
    let uploadData = this.importData.success.filter((obj) => obj.isImport);

    let data: any = await this._filterService.uploadImportExcel({ organisationId: this._organizationService.selectedOrganization, userid: Number(localStorage.getItem("UserId")), data: JSON.stringify(uploadData), Source: this.Source, recordId: this.reportId, isBankTransMode: true });
    this.isFileProcessing = false;
    if (data.status == 1) {
      this.isSpinnerShown = false;
      this.importData = { success: [], error: [], type: 'success', active: false };
      this._toasterMessageService.displayToasterState(ToasterTypes.Success, 'Success', 'Data Upload Successfully...');

      this.CloseFilterSidebar();


      if (this.Source == "Report") {
        let bankPart = this.filter.accounts?.length > 0 ? this.filter.accounts?.map(s => `${s},`).join('').slice(0, -1) : '';
        let str: string = JSON.stringify({ 'account': bankPart.substring(0, bankPart.length), 'DateRangeSelcted': this.DateRangeSelcted });
        this.updateInvoices.emit(str);
      }
      else {
        this.updateInvoices.emit("upload");
      }
    }
    else {
      this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', 'Data Upload Fail...');
    }

  }

  handleReportBlur() {
    this.newReport.ReportName = "";
    this.isCreateReportItemShown = this.isNewReport;
  }

  handleReportName(event) {
    this.newReport.ReportName = event;
    const matchedReport = this.reports?.filter(s => s.reportName.toLowerCase() == this.newReport.ReportName.toLowerCase());

    if (matchedReport?.length == 0 && event) {
      this.isCreateReportItemShown = true;
    } else if (!event) {
      this.handleReportBlur();
    } else {
      this.isCreateReportItemShown = false;
    }
  }
  reportId: string = "";
  onSelectReport(event: ReportShort) {
    this.isLoaded = true;
    this.isNewReportLoaded = true;
    if (event == undefined) {
      this.isNewReport = true;
      return;
    }
    this.isNewReport = false;
    this.isCreateReportItemShown = this.isNewReport;
    this.reportId = event.id;
  }

  createNewReport() {
    if (!this.creatingNewReport) {
      this.creatingNewReport = true;
      this.addNewReport(this.newReport);
    }
  }

  addNewReport(report: NewReport) {

    const name = report.ReportName;
    const newReport = report;
    newReport.CreatedBy = sessionStorage.Id,
      this.creatingNewReport = true;
    newReport.organizationId = this._organizationService.selectedOrganization;
    this.reportServ.createNewReport(newReport)
      .pipe()
      .subscribe(
        (result) => {
          if (result?.reportId == 'ConnectionLost') {
            this._toasterMessageService.displayToasterState(ToasterTypes.Error, null, result?.message);
          }
          else if (result?.message !== undefined) {
            this._toasterMessageService.displayToasterState(ToasterTypes.Error, null, result?.message);
            this.isNewReport = false;
            this.creatingNewReport = false;
            this.isCreateReportItemShown = false;

            const refField = document.getElementById('comment');
            refField.focus();
          }
          else {
            this.mailModel.ID = result.reportId;
            this.reports = [...this.reports, { id: result.reportId, reportName: report.ReportName }];
            this.isNewReport = false;
            this.creatingNewReport = false;
            this.isCreateReportItemShown = false;

            const refField = document.getElementById('comment');

            this.mailModel.ReportName = name;
            refField.focus();
            this.updateCurrentReport();
            this.updateReportStatus();
            $(".ng-dropdown-panel").remove();
            $("#ddlreport").removeClass("ng-select-opened");
          }
        }
      )
  }

  updateReportStatus() {

    if (this.mailModel.ReportName != null) {

      const report = tryGetObjectByProperty(this.reports, 'reportName', this.mailModel.ReportName) as ReportShort;
      this.isNewReportLoaded = report ? true : false;
      this.isNewReport = !report && !this.mailModel.ID ? true : false;
      this.isCreateReportItemShown = this.isNewReport;
      this.newReport.ReportName = this.mailModel.ReportName;
      this.mailModel.ID = report?.id ?? this.mailModel.ID;
    }
  }

  updateCurrentReport() {
    this.currentReport.id = !!this.mailModel.ID ? this.mailModel.ID : this.currentReport?.id;
    this.currentReport.reportName = this.reports.find(s => s.id === this.currentReport.id)?.reportName;
  }

  Cancel() {
    this.closeEvent.emit();
  }

  /** Bridge: receives import completion from ImportTransactionsComponent */
  onImportComplete(payload: string): void {
    this.updateInvoices.emit(payload);
  }

  removeFile() {
    this.fileObj = null;
  }

  toggleStepComplete() {
    this.isStep1Completed = !this.isStep1Completed;
  }

  orgusersList: any = []
  getUsers() {
    this._userService.getUsersByOrganizationId(this._organizationService.selectedOrganization).subscribe((val) => {
      this.orgusersList = val.data;
    });
  }

  onSubmitterItemSelect(item: any) {
    this.filterSubmitters.push(item);
    this.updateFilter('submitters', this.filterSubmitters.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onSubmitterSelectAll(items: any) {
    this.filterSubmitters = items;
    this.selectedSubmitters = items;
    this.updateFilter('submitters', this.filterSubmitters.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onSubmitterDeleteGroup(item: any) {
    this.filterSubmitters = Object.values(this.filterSubmitters).filter(g => g.name != item.name);
    this.updateFilter('submitters', this.filterSubmitters.map(s => s.name.replace('&', '%26')));
    this.selectedSubmitters = this.filterSubmitters;
    this.isDirty = true;
  }

  onSubmitterDeleteAllGroup(item: any) {
    this.filterSubmitters = [];
    this.selectedSubmitters = [];
    this.updateFilter('submitters', this.filterSubmitters.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onAssignToItemSelect(item: any) {
    this.filterAssignedTo.push(item);
    this.updateFilter('assignedTo', this.filterAssignedTo.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onAssignToSelectAll(items: any) {
    this.filterAssignedTo = items;
    this.selectedAssignedTo = items;
    this.updateFilter('assignedTo', this.filterAssignedTo.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  onAssignToDeleteGroup(item: any) {
    this.filterAssignedTo = Object.values(this.filterAssignedTo).filter(g => g.name != item.name);
    this.updateFilter('assignedTo', this.filterAssignedTo.map(s => s.name.replace('&', '%26')));
    this.selectedAssignedTo = this.filterAssignedTo;
    this.isDirty = true;
  }

  onAssignToDeleteAllGroup(item: any) {
    this.filterAssignedTo = [];
    this.selectedAssignedTo = [];
    this.updateFilter('assignedTo', this.filterAssignedTo.map(s => s.name.replace('&', '%26')));
    this.isDirty = true;
  }

  goBack() {
    this.importData.active = false;
  }
}
